<template>
    <div class="right_body action_body">
      <el-form ref="baseForm" :model="searchForm">
        <MaterialSchFormPanel @subSearch="onSubmitQuery" :fromData="searchForm">
            <el-form-item class="item" label="物料：" prop="materialCode">
                <el-input v-model="searchForm.searchCriteria.codeOrDesc" :placeholder="$store.state.remark.matter"></el-input>
            </el-form-item>
            <el-form-item class="item" label="物料类型：" prop="materialType">
                <el-select v-model="searchForm.searchCriteria.materialTypeId"
                           clearable filterable :placeholder="$store.state.remark.matterType">
                    <el-option
                        v-for="item in materialTypes" :key="item.materialTypeId" :label="item.materialTypeDesc" 
                        :value="item.materialTypeId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="item" label="物料组：" prop="materialGroup">
                <el-select v-model="searchForm.searchCriteria.materialGroupId" 
                           filterable :placeholder="$store.state.remark.matterGroup">
                    <el-option
                        v-for="item in mateiralGourpes"
                        :key="item.materialGroupId"
                        :label="item.materialGroupDesc"
                        :value="item.materialGroupId"></el-option>
                </el-select>
            </el-form-item>
        </MaterialSchFormPanel>
      </el-form>

      <ToolBar ref="actionbtn" isBatch @batch="onNewMtrlBatchFeature" ></ToolBar> 
      <MaterialResultTable :columns="tableColumns" :tabList="materialResultSet"
                           :total="resultSetPage.total" :pages="resultSetPage.pages"
                           :fromData="resultSetPage"
                           @changePages="onChangePageSize"
                           @currentChange="onQueryPagesChange"
                           @selectSdata="onSelectedRow"></MaterialResultTable>
      
    </div>
</template>

<script>
   import MaterialSchFormPanel from "components/common/search.vue";
   import MaterialResultTable  from 'components/table/batchList.vue';
   import ToolBar from 'components/btn/listBtn.vue';
   import {matterApi,matterTypeApi,matterGropApi,measureUnitApi,factoryApi} from 'api/base.js';

   export default{
       components:{
          MaterialSchFormPanel,
          MaterialResultTable,
          ToolBar
       },
       data(){
           return {
               searchForm:{
                   searchCriteria:{}
               },
               materialTypes:[],
               mateiralGourpes:[],
               tableColumns:[
                    {field: 'materialCode', title: '物料编码', width:100,need:true,"sortable":true},
                    {field: 'materialDesc', title: '物料描述',need:true,isResize:true},
                    {field: 'materialTypeName', title: '物料类型', width: 100},
                    {field: 'materialGroupDesc', title: '物料组', width: 100},
                    {field: 'specifications', title: '规格', width: 130},
                    {field: 'basicUnitDesc', title: '基本单位', width: 80},
                    {field: 'createDate', title: '创建日期', width: 100},
                    {field: 'maintainStatus', title: '状态', width: 60,
                    formatter: function (rowData,rowIndex,pagingIndex,field) {
                    return rowData.maintainStatus === 'X' ? "已删除" : "正常";
                    }}
                ],
                materialResultSet:[],
                selectedMaterialRow:undefined,
                resultSetPage:{
                    pages:0,
                    total:0,
                    page:1,
				    pageSize:10,
                }
           }
       },
       methods:{
           /**
            * 提交查询
            */
           onSubmitQuery(){
             this.searchForm.page=1;
             this.loadMaterialData();
           },
           /**
            * 新增物料批次特性
            */
           onNewMtrlBatchFeature(){              
              if(!this.selectedMaterialRow){
                  this.$message.error('请选择需要维护的物料');
                  return;
              }
              this.$store.state.cache.batchFeatureMateiral = this.selectedMaterialRow;          
              this.$router.push({name: 'business-sale-batchHelp'});
           },
           /**
            * 切换物料查询页面
            */
           onQueryPagesChange(currentPage){
              this.searchForm.page = currentPage;
              this.loadMaterialData(); 
           },
           /**
            * 更改查询页面大小
            */
           onChangePageSize(pageSize){
              this.searchForm.page = 1;
              this.resultSetPage.pageSize = pageSize;
              this.loadMaterialData();
           },
           /**
            * 选中一行物料
            */
           onSelectedRow(materialDataRow){
              this.selectedMaterialRow = materialDataRow;
           },           
           created(){
               //加载物料类型与物料组
               this.loadMaterialTypeAndGroup();
               this.loadMaterialData();
           },
           updated(){
               this.loadMaterialData();
           },
           async loadMaterialTypeAndGroup(){
              //获取物料类型列表
              let materialType = await this.$post(matterTypeApi.list,this.$store.state.getAllPage);
              if(materialType.status) this.materialTypes = materialType.data.list;

              //获取物料组列表
              let materialGroup = await this.$post(matterGropApi.list,this.$store.state.getAllPage);
              if(MateriamaterialGrouplGroup.status) this.mateiralGourpes = materialGroup.data.list;
           },
            /**
             * 加载物料数据
             */
           async loadMaterialData(){
              this.searchForm.pageSize = this.resultSetPage.pageSize;
              let res = await this.$post(matterApi.list,this.searchForm);
              if(res.status && res.data){
                 this.materialResultSet = res.data.list;
                 this.resultSetPage.pages = res.data.pages;
                 this.resultSetPage.total = res.data.total;
              }else{
                this.materialResultSet = [];
                this.resultSetPage.pages =0;
                 this.resultSetPage.total =0;
              }
            //   this.loading = false;
            //   this.isComponentChild = true;
            },
       }
   }
</script>

